<template>
    <v-dialog-old ref="dialog" id="cropper" @hidden="closeWithoutSave()" v-show="!hidden">
        <div v-if="originalImg !== ''">
            <i class="far fa-question-circle tool-help" aria-hidden="true" v-tooltip="toolParams()"/>
            <div class="buttons-container">
                <div class="top-buttons">
                    <button class="btn-top file-add" @click="showFileChooser"><i class="far fa-folder-open"
                                                                                 aria-hidden="true"/></button>
                    <button class="btn-top" v-if="showResizeByWidthBtn" @click="resizeImgByWidth">
                        <i class="fa fa-expand" aria-hidden="true"/>
                    </button>
                    <button class="btn-top" v-if="showResizeByHeightBtn" @click="resizeImgByHeight">
                        <i class="fa fa-compress" aria-hidden="true"/>
                    </button>
                    <button class="btn-top" @click="rotate(-90)"><i class="fas fa-rotate-left" aria-hidden="true"/></button>
                    <button class="btn-top" @click="rotate(90)"><i class="fas fa-rotate-right" aria-hidden="true"/></button>
                    <button class="btn-top" @mousedown="zoomPlusStart" @mouseup="zoomPlusEnd" @mouseleave="zoomPlusEnd">
                        <i class="fa fa fa-search-plus" aria-hidden="true"/>
                    </button>
                    <button class="btn-top" @mousedown="zoomMinusStart" @mouseup="zoomMinusEnd" @mouseleave="zoomMinusEnd">
                        <i class="fa fa fa-search-minus" aria-hidden="true"/>
                    </button>
                </div>
            </div>

            <drag-and-drop @fileDropped="preloadFile">
                <div class="img-container" :style="'width: ' + widthBox + 'px'">
                    <image-cropper

                        @crop="cropEvent"
                        ref="cropper"
                        :src="originalImg"
                        :minContainerHeight="parseInt(height)+250"
                        :minContainerWidth="widthBox"

                        :minCropBoxWidth="parseInt(width)"
                        :minCropBoxHeight="parseInt(height)"
                        :cropBoxResizable="false"

                        :data="cropBoxData"
                        :wheelZoomRatio="0.02"
                        dragMode="move"
                        :cropBoxMovable="false"

                        :guides="false"
                        :center="false"
                        :responsive="false"

                        @ready="onReadyEvent"
                        @zoom="onZoom"
                        @cropmove="onCropMove"
                    ></image-cropper>
                </div>
            </drag-and-drop>
            <div class="bottom-buttons">
                <v-loading-component @click="crop">
                    <template slot-scope="{ loadingClass }">
                        <button :class="['green btn-crop', loadingClass]">Подтвердить</button>
                    </template>
                </v-loading-component>
            </div>
        </div>
        <input
            type="file" style="display: none"
            accept="image/*"
            ref="uploadInput"
            @input="inputImgLoadEvent"
            multiple
        />
    </v-dialog-old>
</template>

<script>

import imageCropper from 'vue-cropperjs';
import dragAndDrop from '@base/DragAndDrop.vue';
import 'cropperjs/dist/cropper.css';

export default {
    components: {
        'image-cropper': imageCropper,
        'drag-and-drop': dragAndDrop,
    },
    props: {
        img: {
            type: String,
            required: false,
            default: ''
        },
        type: {
          type: String,
          required: true
        },
        uploadUrl: {
            type: String,
            required: true
        },
        width: {
            default: 150,
            required: false
        },
        height: {
          default: 150,
          required: false
        },
        cropBoxDataLeft: {
            default: 125,
            required: false
        },
        widthBox: {
            default: 400,
            required: false
        },
        viewMode: {
            default: 0,
            required: false
        }
    },
    data: function () {
        return {
            show: false,
            detail: {
                height: 0,
                rotate: 0,
                scaleX: 1,
                scaleY: 1,
                width: 0,
                x: 0,
                y: 0
            },
            cropBoxData: {
                width: parseInt(this.width),
                height: parseInt(this.height),
                top: 50,
                left: this.cropBoxDataLeft
            },
            originalImg: '',
            loadedImgData: {},
            previousCropInfo: {},
            hidden: true,
            movePts: 1,
            zoomPlusInterval: undefined,
            zoomMinusInterval: undefined,
            showResizeByHeightBtn: true,
            showResizeByWidthBtn: true,
        };
    },
    methods: {
        toolParams() {
            return {
                content: `     <div class="tooltip-content">
            <table>
                <tr>
                    <td>Загрузить новый файл</td>
                    <td>  &nbsp;&nbsp;<i class="far fa-folder-open" aria-hidden="true"/></td>
                </tr>
                <tr>
                    <td>Resize по ширине</td>
                    <td>  &nbsp;&nbsp;<i class="fa fa-expand" aria-hidden="true"/></td>
                </tr>
                <tr>
                    <td>Resize по высоте</td>
                    <td>  &nbsp;&nbsp;<i class="fa fa-compress" aria-hidden="true"/></td>
                </tr>
                <tr>
                    <td>Повернуть по часовой (90)</td>
                    <td>  &nbsp;&nbsp;<i class="fa fa-repeat" aria-hidden="true"/></td>
                </tr>
                <tr>
                    <td>Повернуть против часовой</td>
                    <td>  &nbsp;&nbsp;<i class="fa fa-undo" aria-hidden="true"/></td>
                </tr>
                <tr>
                    <td>Приблизить на 10%</td>
                    <td>  &nbsp;&nbsp;<i class="fa fa-search-plus" aria-hidden="true"/></td>
                </tr>
                <tr>
                    <td>Отдалить на 10%</td>
                    <td>  &nbsp;&nbsp;<i class="fa fa-search-plus" aria-hidden="true"/></td>
                </tr>
            </table>
            <br/>
            <div>
                1. Доступен сдвиг картинки на 5px стрелочками клавиатуры <br/>
                2. Можно перетаскивать новые файлы прямо на диалоговое окно
            </div>
        </div>`
            }
        },
        removeEventListeners () {
            window.removeEventListener("keydown", this.keydownEvent, false);
            window.removeEventListener("keyup",this.keyupEvent , false);
        },
        keydownEvent (e) {
            if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].indexOf(e.code) > -1) {
                e.preventDefault();
            }
            if (e.key && e.key === 'ArrowUp') {
                if (
                    this.viewMode === 0 ||
                    document.querySelector('.cropper-crop-box').getBoundingClientRect().bottom - document.querySelector('.cropper-canvas').getBoundingClientRect().bottom + this.movePts < 0
                ) {
                    this.move(0, -this.movePts)
                }
            }
            if (e.key && e.key === 'ArrowDown') {
                if (
                    this.viewMode === 0 ||
                    document.querySelector('.cropper-canvas').getBoundingClientRect().top - document.querySelector('.cropper-crop-box').getBoundingClientRect().top + this.movePts < 0
                ) {
                    this.move(0, this.movePts)
                }
            }
            if (e.key && e.key === 'ArrowLeft') {
                if (
                    this.viewMode === 0 ||
                    document.querySelector('.cropper-crop-box').getBoundingClientRect().right - document.querySelector('.cropper-canvas').getBoundingClientRect().right + this.movePts < 0
                ) {
                    this.move(-this.movePts, 0)
                }
            }
            if (e.key && e.key === 'ArrowRight') {
                if (
                    this.viewMode === 0 ||
                    document.querySelector('.cropper-crop-box').getBoundingClientRect().left - document.querySelector('.cropper-canvas').getBoundingClientRect().left - this.movePts > 0
                ) {
                    this.move(this.movePts, 0)
                }
            }
        },
        keyupEvent (e) {
            e = e || event;
            if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].indexOf(e.code) > -1) {
                e.preventDefault();
            }
        },
        initEventListeners () {
            window.addEventListener("keydown", this.keydownEvent, false);
            window.addEventListener("keyup", this.keyupEvent, false);
        },
        inputImgLoadEvent(e) {
            this.initEventListeners();
            this.preloadFile(event.currentTarget.files[0])
            this.$refs.uploadInput.value='';
        },
        getCropInfo() {
            let cropInfo = this.cropBoxData.width+'x'+this.cropBoxData.height;
            let imgName = this.img.slice(this.img.lastIndexOf("/") + 1, this.img.length)
            this.axios.get("/imgInfo/" + this.type + '/' + cropInfo + '/'+ imgName).then((data) => {
                this.loadedImgData = data.data.imgInfo;
                if (this.loadedImgData.status === 'FOUND') {
                    this.originalImg = this.loadedImgData.originalImgPath;
                    this.previousCropInfo = this.loadedImgData.cropData;
                } else {
                    if (this.loadedImgData.originalExists === true){
                        this.originalImg = this.loadedImgData.originalUrl;
                    }else if(this.loadedImgData.cropExists === true){
                        this.originalImg = this.loadedImgData.croppedImg;
                    }
                }
            })
        },
        cropEvent(e) {
            this.detail = e.detail
        },
        crop(btn) {
            btn.startLoadingAnimation();

            let canvasData = this.$refs.cropper.getCanvasData();
            let params = {
                name: Math.floor(Date.now() / 1000),
                imageWidth: canvasData.width,
                imageHeight: canvasData.height,
                originalData: this.originalImg,
                cropWidth: parseInt(this.width),
                cropHeight: parseInt(this.height),
                left: canvasData.left - this.cropBoxData.left,
                top: canvasData.top - this.cropBoxData.top,
                canvasData: canvasData,
                detail: this.detail
            }
            this.axios.post(this.uploadUrl, params)
                .then((data) => {
                    btn.stopLoadingAnimation();
                    this.$emit('crop-upload-success', data.data.url);
                    this.$refs.dialog.visible = false;
                    this.removeEventListeners();
                })
                .catch(() => btn.stopLoadingAnimation());
        },
        closeWithoutSave() {
            this.originalImg = '';
            this.$emit('canceled');
            this.hidden = true;
            this.removeEventListeners();
        },
        onZoom(e) {
            this.$nextTick(() => {
                if (this.isOverLimit() && e.detail.ratio < e.detail.oldRatio) {
                    if (
                        document.querySelector('.cropper-view-box').clientWidth <= document.querySelector('.cropper-canvas').clientWidth
                        && document.querySelector('.cropper-view-box').clientHeight <= document.querySelector('.cropper-canvas').clientHeight
                    ) {
                        this.moveToTheLimits();
                    } else {
                        this.$refs.cropper.zoomTo(e.detail.oldRatio);
                    }

                    if (e.detail.originalEvent instanceof WheelEvent) {
                        this.onCropMove();
                    }
                }
            })
        },
        onCropMove() {
            this.$nextTick(() => {
                if (this.isOverLimit()) {
                    this.moveToTheLimits();
                }
            })
        },
        moveToTheLimits() {
            let coordX = 0, coordY = 0;

            if (document.querySelector('.cropper-canvas').getBoundingClientRect().left > document.querySelector('.cropper-crop-box').getBoundingClientRect().left) {
                coordX = document.querySelector('.cropper-crop-box').getBoundingClientRect().left - document.querySelector('.cropper-canvas').getBoundingClientRect().left;
            }

            if (document.querySelector('.cropper-canvas').getBoundingClientRect().right < document.querySelector('.cropper-crop-box').getBoundingClientRect().right) {
                coordX = document.querySelector('.cropper-crop-box').getBoundingClientRect().right - document.querySelector('.cropper-canvas').getBoundingClientRect().right;
            }

            if (document.querySelector('.cropper-canvas').getBoundingClientRect().bottom < document.querySelector('.cropper-crop-box').getBoundingClientRect().bottom) {
                coordY = document.querySelector('.cropper-crop-box').getBoundingClientRect().bottom - document.querySelector('.cropper-canvas').getBoundingClientRect().bottom;
            }

            if (document.querySelector('.cropper-canvas').getBoundingClientRect().top > document.querySelector('.cropper-crop-box').getBoundingClientRect().top) {
                coordY = document.querySelector('.cropper-crop-box').getBoundingClientRect().top - document.querySelector('.cropper-canvas').getBoundingClientRect().top;
            }

            this.$refs.cropper.move(coordX, coordY);
        },
        isOverLimit() {
            if (this.viewMode === 0) {
                return false;
            }

            return document.querySelector('.cropper-canvas').getBoundingClientRect().left > document.querySelector('.cropper-crop-box').getBoundingClientRect().left ||
                document.querySelector('.cropper-canvas').getBoundingClientRect().right < document.querySelector('.cropper-crop-box').getBoundingClientRect().right ||
                document.querySelector('.cropper-canvas').getBoundingClientRect().top > document.querySelector('.cropper-crop-box').getBoundingClientRect().top ||
                document.querySelector('.cropper-canvas').getBoundingClientRect().bottom < document.querySelector('.cropper-crop-box').getBoundingClientRect().bottom;
        },
        onReadyEvent() {
            this.$refs.cropper.setCropBoxData(this.cropBoxData)
            let origImageData = this.$refs.cropper.getImageData();

            if (Object.keys(this.previousCropInfo).length > 0) {
                let width = origImageData.naturalWidth / (this.previousCropInfo.width / this.cropBoxData.width);
                let height =  origImageData.naturalHeight / (this.previousCropInfo.height / this.cropBoxData.height);
                const even = n => !(n % 2);
                let params = {
                    height: even(this.previousCropInfo.rotate/90) ? height : width,
                    width: even(this.previousCropInfo.rotate/90) ? width : height,
                    top: this.cropBoxData.top - this.previousCropInfo.y / (this.previousCropInfo.height / this.cropBoxData.height),
                    left: this.cropBoxData.left - this.previousCropInfo.x / (this.previousCropInfo.width / this.cropBoxData.width),
                }
                this.rotate(this.previousCropInfo.rotate);
                this.$refs.cropper.setCanvasData(params);
            } else {
                this.resizeByMax()
                this.centralize()
            }
            if (this.originalImg.startsWith("data:image/svg+xml")) {
                this.originalImg = this.$refs.cropper.getCroppedCanvas({
                    imageSmoothingQuality: 'high',
                    minWidth: this.cropBoxData.width,
                    minHeight: this.cropBoxData.height
                }).toDataURL('image/png');
                this.$refs.cropper.replace(this.originalImg);
            } else {
                this.hidden = false;
            }

            if (this.viewMode !== 0) {
                if (this.width / this.height > origImageData.width / origImageData.height) {
                    this.showResizeByWidthBtn = true;
                    this.showResizeByHeightBtn = false;
                } else {
                    this.showResizeByWidthBtn = false;
                    this.showResizeByHeightBtn = true;
                }
            }
        },
        resizeImgByWidth() {
            this.$refs.cropper.setCanvasData({width: this.cropBoxData.width})
            this.centralize()
        },
        resizeImgByHeight() {
            this.$refs.cropper.setCanvasData({height: this.cropBoxData.height})
            this.centralize()
        },
        resizeByMax() {
            let imgData = this.$refs.cropper.getImageData();
            if (imgData.height > imgData.width) {
                this.$refs.cropper.setCanvasData({height: this.cropBoxData.height})
            } else {
                this.$refs.cropper.setCanvasData({width: this.cropBoxData.width})
            }
        },
        centralize() {
            let imgData = this.$refs.cropper.getImageData();

            let imgDataHeight = this.isRotated() ? imgData.width : imgData.height;
            let imgDataWidth = this.isRotated() ? imgData.height : imgData.width;

            let top = this.cropBoxData.top + (this.cropBoxData.height - imgDataHeight) / 2
            this.$refs.cropper.setCanvasData({top: top})
            let left = this.cropBoxData.left + (this.cropBoxData.width - imgDataWidth) / 2
            this.$refs.cropper.setCanvasData({left: left})
        },
        preloadFile(file) {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                this.originalImg = reader.result;
                this.previousCropInfo = {};
                if (this.originalImg !== '' && typeof this.$refs.cropper !== 'undefined') {
                    this.hidden = true;
                    this.$refs.cropper.replace(this.originalImg);
                }
              this.normalizeImg();

            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        },
         normalizeImg() {
           setTimeout( () => {
             let imgData = this.$refs.cropper.getImageData();
             if(imgData.height < this.cropBoxData.height){
               this.resizeImgByHeight();
             }else if(imgData.width < this.cropBoxData.width){
               this.resizeImgByWidth();
             }

           }, 125);
         },
        showModal: function () {
            this.initEventListeners();
            this.$refs.dialog.show();

            if (Object.keys(this.loadedImgData).length > 0) {
                if (this.loadedImgData.status === 'FOUND'){
                    this.previousCropInfo = this.loadedImgData.cropData;
                    this.originalImg = this.loadedImgData.originalImgPath;
                }else{
                    if (this.loadedImgData.originalExists === true){
                        this.originalImg = this.loadedImgData.originalUrl;
                        this.normalizeImg();
                    }else if(this.loadedImgData.cropExists === true){
                        this.originalImg = this.loadedImgData.croppedImg;
                    }else{
                        this.showFileChooser();
                    }
                }
            }
        },
        move(offsetX, offsetY) {
            this.$refs.cropper.move(offsetX, offsetY);
        },
        rotate(deg) {
            this.$refs.cropper.rotate(deg);

            if (this.viewMode !== 0) {
                let origImageData = this.$refs.cropper.getImageData();

                let height = this.isRotated() ? origImageData.width : origImageData.height;
                let width = this.isRotated() ? origImageData.height : origImageData.width;

                if (this.width / this.height > width / height) {
                    this.showResizeByWidthBtn = true;
                    this.showResizeByHeightBtn = false;
                    this.resizeImgByWidth();
                } else {
                    this.showResizeByWidthBtn = false;
                    this.showResizeByHeightBtn = true;
                    this.resizeImgByHeight();
                }

                if (this.isRotated()) {
                    if (this.showResizeByHeightBtn) {
                        this.resizeImgByHeight();
                    } else {
                        this.resizeImgByWidth();
                    }
                }
            }
        },
        showFileChooser() {
            this.$refs.dialog.show();
            setTimeout(() => {
                this.$refs.uploadInput.click();
            }, 50)
        },
        zoom(percent) {
            this.$refs.cropper.relativeZoom(percent);
        },
        zoomPlusStart() {
            this.zoomPlusInterval = setInterval(() => this.zoom(0.02), 50);
        },
        zoomPlusEnd() {
            if (this.zoomPlusInterval) {
                clearInterval(this.zoomPlusInterval);
            }
        },
        zoomMinusStart() {
            this.zoomMinusInterval = setInterval(() => this.zoom(-0.02), 50);
        },
        zoomMinusEnd() {
            if (this.zoomMinusInterval) {
                clearInterval(this.zoomMinusInterval);
            }
        },
        isRotated() {
            const deg = Math.abs(this.detail.rotate);

            return deg === 90 || deg === 270;
        }
    },

    watch: {
        img: {
            immediate: true,
            handler(newVal) {
                if (newVal !== '') {
                    this.getCropInfo();
                } else {
                    this.loadedImgData = {};
                    this.originalImg = '';
                    this.previousCropInfo = {};
                }
            }
        }
    }
}
</script>

<style lang="scss">
.cropper-bg {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAHklEQVQ4T2P8////fwYKAOOoAQyjYcAwGgYMwyIMACUfP9Eb4ExuAAAAAElFTkSuQmCC") !important
}

.cropper-view-box {
    outline: 2px solid #39f;
}

.cropper-crop-box {
    background: white;
}

.cropper-modal {
    opacity: 0.85;
    background: #FFFFFF;
}

.btn-top {
    padding: 0;
    width: 30px;
    height: 20px;
}

.file-add:hover {
    color: green !important;
}

.btn-crop {
    margin-top: 5px;
    margin-left: 34%;
}

.bottom-buttons {
    margin-left: 15.5px;
    display: inline;
    width: 75px !important;
}

.buttons-container {
    width: 100%;
}

.top-buttons {
    margin: 0 auto;
    width: max-content;
}

.img-container {
    margin-left: 3px;
    height: 375px;
    margin-top: 9px;
    overflow: hidden;
}

.tool-help {
    float: left;
    color: grey;
    cursor: pointer;
}

.tool-help:hover {
    color: black;
}

.imageCropper {
    position: relative;

    button.resetBtn {
        position: absolute;
        top: 2px;
        right: 2px;
    }

    button.editBtn {
        position: absolute;
        top: 2px;
        right: 25px;
    }

    img {
        border: solid 1px #EEEEEE;
        box-sizing: content-box;
    }
}

#cropper {
    width: 510px;
    height: 600px;
}
.cropper-face{
    opacity: 0 !important;
}
</style>
